// if (window.location.hash) {
//   // console.log(window.location.hash);

//   var targetElement = document.querySelector(window.location.hash);
//   if (targetElement) {
//     var topNav = document.querySelector("#header");

//     var topNavHeight = topNav ? topNav.offsetHeight : 0;

//     // console.log('topNavHeight', topNavHeight);
//     // console.log('targetElement', targetElement.getBoundingClientRect().top + window.pageYOffset);
//     var scrollToPosition =
//       targetElement.getBoundingClientRect().top +
//       window.pageYOffset -
//       topNavHeight;
//     window.scroll({
//       top: scrollToPosition,
//       behavior: "smooth",
//     });
//   }
// }

const validationPatterns = {
  phoneNumber: /^((\(\d{3}\)?)|(\d{3}))([\s-./]?)(\d{3})([\s-./]?)(\d{4})$/,
  pinNumber: /^([1-9](?=.*[0-9]).{3,5})$/,
  passcodeNumber:
    /^(?!.*(\d)\1{2})(?!.*(012|123|234|345|456|567|678|789|890|901|210|321|432|543|654|765|876|987|098|109))([1-9](?=.*[0-9]).{3,5})$/,
  ssNumber: /^([0-9]{9})$/,
  strongPassword:
    /^(?!.*(123|234|345))(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{7,20}$/,
  zipCode: /^[0-9]{5}(?:-[0-9]{4})?$/,
  emailUsername: /^[a-zA-Z0-9.-]+$/,
  emailAddress:
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
};

(function ($) {
  // Open My Account modal
  $('a[href*="#ns-account-login"]').click(function (e) {
    if ($("#loginModal").length) {
      e.preventDefault();
      $("#loginModal").modal("show");
    }
  });

  // Validate form field
  $(
    "input[data-validate-pattern]:required, select[data-validate-pattern]:required, textarea[data-validate-pattern]:required"
  ).each(function () {
    $(this).on("change keyup blur focus", function () {
      var vPattern = $(this).attr("data-validate-pattern");
      if (vPattern in validationPatterns) {
        if (validationPatterns[vPattern].test($(this).val())) {
          // Is valid input
          $(this).removeClass("is-invalid");
          $(this).addClass("is-valid");
        } else {
          // Is invalid input
          $(this).addClass("is-invalid");
          $(this).removeClass("is-valid");
        }
      }
    });
  });

  // Add field matching validation
  $(
    "input[data-validate-match]:required, select[data-validate-match]:required, textarea[data-validate-match]:required"
  ).each(function () {
    $(this).on("change keyup blur focus", function () {
      var matchingElement = $(this).attr("data-validate-match");
      // console.log("match eval:", matchingElement, $(this).val(), $(matchingElement).val());
      if ($(this).val() === $(matchingElement).val()) {
        // Is valid input
        $(this).removeClass("is-invalid");
        $(this).addClass("is-valid");
      } else {
        // Is invalid input
        $(this).addClass("is-invalid");
        $(this).removeClass("is-valid");
      }
    });
  });

  // Remove the doing_wp_cron thing
  setTimeout(function () {
    var hash = $(location).attr("hash");
    // console.log("hash", hash);
    history.replaceState &&
      history.replaceState(
        null,
        "",
        location.pathname +
          location.search
            .replace(/[\?&]doing_wp_cron=[^&]+/, "")
            .replace(/^&/, "?") +
          hash
      );
  }, 500);

  $(".button.help").click(function (e) {
    e.preventDefault();
  });

  // $('a:empty').each(function() {
  //   $(this).remove();
  // });

  // capture user id
  if (urlParamNS("sid")) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "authentication",
      userID: urlParamNS("sid"),
    });
    // console.log("GTM: User ID - Authentication " + urlParamNS("sid"));
  }

  var urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get("agent") !== null) {
    var agentID = urlParams.get("agent");
    sessionStorage.setItem("lumos_agent_id", agentID);
  }

  if (sessionStorage.getItem("lumos_agent_id") !== null) {
    $("[data-referral]").removeClass("hide");
    $("#account_service_agent_id").val(
      sessionStorage.getItem("lumos_agent_id")
    );
  }
})(jQuery);

jQuery(document).ready(function ($) {
  if (urlParamNS("tune_offer_id")) {
    // sessionStorage.setItem('tune_offer_id', urlParamNS('tune_offer_id'));

    // console.log("Set Tune Offer", urlParamNS("tune_offer_id"));
    var cookieExpires = 30; // days
    Cookies.set("lumos_tune_offer_id", urlParamNS("tune_offer_id"), {
      expires: cookieExpires,
    });
  }
});

function toggleAddressChecker() {
  $("#addressCheckerModal").modal("show");
}

function formatDate(objDate) {
  var d = objDate;
  // console.log(d);
  if (!(objDate instanceof Date)) {
    d = new Date(objDate);
  }
  // console.log(d);
  return d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
} // end formatDate()

function convertDateForIos(date) {
  var arr = date.split(/[- :]/);
  date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
  return date;
}

function formatDateAPI(date) {
  var d = date;
  if (!(date instanceof Date)) {
    d = new Date(date);
  }
  var month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    hour = "" + d.getHours(),
    minute = "" + d.getMinutes(),
    second = "" + d.getSeconds();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  if (hour.length < 2) hour = "0" + hour;
  if (minute.length < 2) minute = "0" + minute;
  if (second.length < 2) second = "0" + second;

  return [year, month, day].join("-") + " " + [hour, minute, second].join(":");
}

function formatPhone(phone) {
  var phone_format = String(phone);
  phone_format = phone_format.replace(/\D[^\.]/g, "");
  phone_format =
    phone_format.slice(0, 3) +
    "-" +
    phone_format.slice(3, 6) +
    "-" +
    phone_format.slice(6);

  return phone_format;
} // formatPhone(phone)

function countProperties(obj) {
  var count = 0;

  for (var property in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, property)) {
      count++;
    }
  }
  return count;
}

function isCookiesEnabled() {
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled) {
    document.cookie = "testcookie";
    cookieEnabled = document.cookie.indexOf("testcookie") != -1;
  }
  return cookieEnabled;
}

function urlParamNS(name) {
  var results = new RegExp("[?&]" + name + "=([^&#]*)", "i").exec(
    window.location.href
  );
  if (results == null) {
    return null;
  }
  return decodeURI(results[1]) || 0;
}

function logNSEvent(event_label) {
  var $ = jQuery;

  // Existing API call
  // $.ajax({
  //   url: '/wp-content/themes/lumos-tidewater/api_helper.php',
  //   method: 'POST',
  //   contentType: 'application/x-www-form-urlencoded',
  //   data: {
  //     'action': 'ns_event_log',
  //     'event': event_label,
  //     'event_url': window.location.href
  //   },
  //   success: function(result) {
  //     console.log(result);
  //   }
  // });
  //
  // // New API call
  // var journeyDetails = {
  //   details: event_label
  // };
  //
  // $.ajax({
  //   url: '/wp-json/journey-log/v1/log',
  //   method: 'POST',
  //   contentType: 'application/json',
  //   data: JSON.stringify({ journey_details: JSON.stringify(journeyDetails) }),
  //   success: function(result) {
  //     console.log(result.message);
  //   },
  //   error: function(error) {
  //     console.error('Error logging customer journey:', error);
  //   }
  // });
}

// (function(){
//   // Save the original method in a private variable
//   var _privateLog = console.log;
//   // Redefine console.log method with a custom function
//   console.log = function (message) {
//     // Here execute something with the given message or arguments variable
//     // alert("Our Custom Log Says: " + message);
//     // if(typeof hj !== "undefined") {
//     //   // Fire HotJar event
//     //   var eventLog = 'ConsoleLog: ' + JSON.stringify(message);
//     //   hj('event', eventLog);
//     // }
//
//     /**
//       Note: If you want to preserve the same action as the original method does
//       then use the following line :
//
//       we use apply to invoke the method on console using the original arguments.
//       Simply calling _privateLog(message) would fail because LOG depends on the console
//      */
//     _privateLog.apply(console, arguments);
//   };
// })();

var lsLabel_full_address = "lumos_address_full_address",
  lsLabel_place_id = "lumos_address_place_id",
  lsLabel_location_id = "lumos_location_id",
  lsLabel_address_id = "lumos_address_id",
  lsLabel_address_status = "lumos_address_status",
  lsLabel_address_check_decline = "lumos_address_check_decline",
  lsLabel_address_city = "lumos_address_city",
  lsLabel_address_city_id = "lumos_address_city_id",
  lsLabel_address_state = "lumos_address_state",
  lsLabel_address_state_id = "lumos_address_state_id",
  lsLabel_address_street = "lumos_address_street",
  lsLabel_address_street_id = "lumos_address_street_id",
  lsLabel_address_zip = "lumos_address_zip",
  lsLabel_address_house_num = "lumos_address_house_num",
  lsLabel_address_apt_num = "lumos_address_apt_num",
  lsLabel_address_multigig = "lumos_address_multigig",
  lsLabel_address_iqport = "lumos_address_iqport",
  lsLabel_address_market = "lumos_address_market",
  lsLabel_address_tech_stack = "lumos_address_tech_stack",
  lsLabel_address_promotion_zone = "lumos_address_promotion_zone";

lsLabel_address_newstack = "lumos_address_newstack";
lsLabel_address_supportsvideo = "lumos_address_supportsvideo";
lsLabel_address_precisely_id = "lumos_address_precisely_id";
lsLabel_address_universaladdress_id = "lumos_address_universaladdress_id";

function setAddressCookieData(addressData) {
  if (
    addressData.SupportsGigabit ||
    addressData.LumosService ||
    addressData.NewStack
  ) {
    // localStorage.setItem(lsLabel_place_id, placeID);
    localStorage.setItem(lsLabel_location_id, addressData.LocationID);
    localStorage.setItem(lsLabel_address_id, addressData.Id);
    // if(addressData.UniversalAddressID) {
    //   localStorage.setItem(lsLabel_address_id, addressData.UniversalAddressID);
    // }
    localStorage.setItem(lsLabel_full_address, addressData.FullAddress);
    localStorage.setItem(lsLabel_address_status, true);

    // console.log(addressData.City, "address data city");
    localStorage.setItem(lsLabel_address_city, addressData.City);
    localStorage.setItem(lsLabel_address_city_id, addressData.CityID);
    localStorage.setItem(lsLabel_address_state, addressData.State);
    localStorage.setItem(lsLabel_address_state_id, addressData.StateID);
    localStorage.setItem(lsLabel_address_street, addressData.Address);
    localStorage.setItem(lsLabel_address_street_id, addressData.StreetID);
    localStorage.setItem(lsLabel_address_zip, addressData.Zip);
    localStorage.setItem(lsLabel_address_house_num, addressData.HouseNum);
    localStorage.setItem(lsLabel_address_apt_num, addressData.ApartmentNum);
    localStorage.setItem(lsLabel_address_iqport, addressData.IQPort);
    localStorage.setItem(
      lsLabel_address_promotion_zone,
      addressData.PromotionZone
    );
    localStorage.setItem(lsLabel_address_check_decline, 1);

    var cookieExpires = 1;
    Cookies.set("STYXKEY_lumos_promo_zone", addressData.PromotionZone, {
      expires: cookieExpires,
    });

    localStorage.setItem(lsLabel_address_multigig, addressData.MultiGIG);
    var cookieExpires = 1;
    Cookies.set("STYXKEY_lumos_address_multigig", addressData.MultiGIG, {
      expires: cookieExpires,
    });
    localStorage.setItem(lsLabel_address_newstack, addressData.NewStack);
    localStorage.setItem(
      lsLabel_address_supportsvideo,
      addressData.SupportsVideo
    );
    localStorage.setItem(lsLabel_address_precisely_id, addressData.PreciselyID);
    localStorage.setItem(
      lsLabel_address_universaladdress_id,
      addressData.UniversalAddressID
    );

    $("[data-multigig-notice]").addClass("hide");
  } else {
    // localStorage.setItem(lsLabel_place_id, placeID);
    localStorage.setItem(lsLabel_location_id, "-1");
    localStorage.setItem(lsLabel_address_id, "-1");
    localStorage.setItem(lsLabel_address_status, false);

    localStorage.setItem(lsLabel_address_check_decline, 1);
  }

  // Dispatch custom event
  const event = new Event("lumosAddressChange");
  window.dispatchEvent(event);

  checkAddressLS();
}

function checkAddressLS() {
  if (
    localStorage.getItem(lsLabel_full_address) &&
    localStorage.getItem(lsLabel_full_address).length
  ) {
    // console.log(localStorage.getItem(lsLabel_full_address));

    // Adjust for the show-for-cookie field
    $("[data-show-for-cookie]").each(function () {
      var dataCookie = $(this).attr("data-show-for-cookie");

      if (
        localStorage.getItem(dataCookie) &&
        localStorage.getItem(dataCookie) !== "null" &&
        localStorage.getItem(dataCookie) !== "0"
      ) {
        $(this).removeClass("hide");
        // Alert
        $('[data-cookie-alert="' + dataCookie + '"]').addClass("hide");
      } else {
        $(this).addClass("hide");
        if ($(this).find("input").prop("checked")) {
          if ($(this).prev().find("input").length) {
            $(this).prev().find("input").prop("checked", true).change();
          }
          // Alert
          $('[data-cookie-alert="' + dataCookie + '"]').removeClass("hide");
        }
      }
    });

    $(".show-for-feac").each(function () {
      $(this).addClass("show");
    });

    $(".hide-for-feac").each(function () {
      $(this).addClass("hide");
    });

    $("[data-hide-for-cookie]").each(function () {
      var dataCookie = $(this).attr("data-hide-for-cookie");

      // console.log(dataCookie);
      // console.log(localStorage.getItem(dataCookie));

      if (
        localStorage.getItem(dataCookie) &&
        localStorage.getItem(dataCookie) !== "null" &&
        localStorage.getItem(dataCookie) !== "0"
      ) {
        $(this).addClass("hide");
        // console.log("set hide");
      } else {
        // console.log("remove hide");
        $(this).removeClass("hide");
      }
    });

    $("#availability-status .full-address").text(
      localStorage.getItem(lsLabel_full_address)
    );
    $("#availability-status .check").css({ display: "none" });
    $("#availability-status .avail-icon.alert").css({ display: "none" });

    $(".button.next-step").each(function () {
      $(this).attr("data-state", localStorage.getItem("lumos_address_state"));
    });

    // send state data to gtm
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "data-state": localStorage.getItem("lumos_address_state"),
    });

    if (localStorage.getItem(lsLabel_address_status) !== "false") {
      $("#availability-status .avail-icon.no").css({ display: "none" });
      $("#availability-status .avail-icon.yes").css({
        display: "inline-block",
      });

      if ($("#account_service_geocoded").length) {
        $("#account_service_geocoded").val(
          localStorage.getItem(lsLabel_full_address)
        );
        $("#account_service_geocoded_visible").val(
          localStorage.getItem("lumos_address_street") +
            " " +
            localStorage.getItem("lumos_address_state") +
            ", " +
            localStorage.getItem("lumos_address_city") +
            " " +
            localStorage.getItem("lumos_address_zip")
        );

        $("#service_address_final").text(
          localStorage.getItem(lsLabel_full_address)
        );

        $("#account_service_check_address").text("Change Address");
        // $('#address-checker').removeClass('open');
      }
    } else {
      $("#availability-status .avail-icon.no").css({
        display: "inline-block",
      });
      $("#availability-status .avail-icon.yes").css({ display: "none" });

      if ($("#account_service_geocoded").length) {
        $("#account_service_geocoded").val("");
        $("#account_service_geocoded_visible").val("");
        $("#account_service_check_address").text("Set Address");
      }
    }

    $("#availability-status .avail-icon.edit").css({
      display: "inline-block",
    });
  } else {
    $("#availability-status .avail-icon.alert").css({
      display: "inline-block",
    });
    $("#availability-status .avail-icon.no").css({ display: "none" });
    $("#availability-status .avail-icon.yes").css({ display: "none" });

    $("#availability-status .check").css({ display: "inline-block" });
    $("#availability-status .full-address").text("");

    $("#availability-status .avail-icon.edit").css({ display: "none" });

    $(".show-for-feac").each(function () {
      $(this).removeClass("show");
    });

    $(".hide-for-feac").each(function () {
      $(this).removeClass("hide");
    });
  }
}

function isNumeric(str) {
  if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}

function pushGA4Address(event, addObj) {
  // console.log('GA4 Push', event, addObj);
  // gtag('event', event, addObj);

  var ga4DL = {
    event: event,
    addObj,
  };

  // console.log("GA4 Push", event, ga4DL);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(ga4DL);
}

function logJourney(eventDetails) {
  // Modify eventDetails object to add in email
  eventDetails.user_email = localStorage.getItem("lumos_address_email") || "";
  // get all local storage values, append to a local_storage_data
  var local_storage_data = {};
  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i);
    local_storage_data[key] = localStorage.getItem(key);
  }
  eventDetails.local_storage_data = JSON.stringify(local_storage_data);
  // Make API call to backend
  $.ajax({
    url: "/wp-json/journey-log/v1/log",
    method: "POST",
    contentType: "application/json",
    data: JSON.stringify({ journey_details: eventDetails }),
    success: function (result) {
      // console.log(result.message);
    },
    error: function (error) {
      console.error("Error logging customer journey:", error);
    },
  });
}
async function updatePageProducts() {
  // envConsoleLog("updatePageProducts");
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "POST",
      data: {
        action: "update_card_slider",
      },
      success: function (response) {
        // envConsoleLog("updatePageProducts response", response);
        if (
          $(".wf-speed-cards:not(.shop-fiber):not(.business-cards)").length > 0
        ) {
          try {
            $(
              ".wf-speed-cards:not(.shop-fiber):not(.business-cards)"
            ).replaceWith(response);
            initSpeedCardSlider();
            initSpeedSliderFunctions();
            resolve(); // Resolve the promise
          } catch (e) {
            envConsoleLog(e);
            reject(e); // Reject the promise if there's an error
          }
        } else {
          resolve();
        }
      },
      error: function (error) {
        envConsoleLog("AJAX error:", error);
        reject(error); //handle AJAX errors
      },
    });
  });
}

function updateDisclaimerSection(promoDisclaimer) {
  jQuery.ajax({
    url: "/wp-admin/admin-ajax.php",
    type: "POST",
    data: {
      action: "fetch_disclaimer",
      promoDisclaimer: promoDisclaimer,
    },
    success: function (response) {
      envConsoleLog("disclaimer promoDisclaimer", promoDisclaimer);
      jQuery("#disclaimer-section").replaceWith(response);
    },
    error: function (xhr, status, error) {
      console.error("An error occurred: " + error);
    },
  });
}

// update products on page load to ensure data from js is setting products
$(document).ready(function () {
  if (!$(".wf-speed-cards .card.no_sales_info").length > 0) {
    // updatePageProducts();
  } else {
    setEqualCardHeight();
  }
});

function setEqualCardHeight() {
  let noSalesInfoCards = document.querySelectorAll(
    ".speed-cards-carousel .card.no_sales_info"
  );

  if (noSalesInfoCards.length == 0) {
    let max_height = 0;

    // console.log("setEqualCardHeight");

    let flashSaleInfos = document.querySelectorAll(
      ".speed-cards-carousel .card .flash-sale-info"
    );

    // console.log("no sale info", noSalesInfoCards);

    // console.log(flashSaleInfos.length, noSalesInfoCards.length);
    if (!flashSaleInfos.length && !noSalesInfoCards.length) {
      return; // skip if no flash sale infos and no cards with .no_sales_info
    }

    let anyHidden = Array.from(
      document.querySelectorAll(".flash-sale-info")
    ).some((el) => {
      return window.getComputedStyle(el).display === "none";
    });
    if (anyHidden) {
      // console.log("hidden");
      return;
    }

    //set flash sale info heights equal to tallest
    document
      .querySelectorAll(".speed-cards-carousel .flash-sale-info")
      .forEach((el) => {
        el.style.height = "auto!important";
      });

    document
      .querySelectorAll(".speed-cards-carousel .flash-sale-info")
      .forEach((el) => {
        var height = el.offsetHeight;
        if (height > max_height) {
          max_height = height;
        }
      });

    document
      .querySelectorAll(".speed-cards-carousel .flash-sale-info")
      .forEach((el) => {
        el.style.height = max_height + "px!important";
      });

    //set margin top to 75% of the height of flash-sale-info
    document.querySelectorAll(".speed-cards-carousel .card").forEach((card) => {
      card.style.marginTop = max_height * 0.75 + "px";
    });
  }

  if (noSalesInfoCards.length > 0) {
    // console.log("no sales info cards");
    let card_max_height = 0;
    //set card heights equal to tallest
    document.querySelectorAll(".speed-cards-carousel .card").forEach((el) => {
      el.style.height = "auto!important";
    });

    document.querySelectorAll(".speed-cards-carousel .card").forEach((el) => {
      var height = el.offsetHeight;
      if (height > card_max_height) {
        card_max_height = height;
      }
    });

    document.querySelectorAll(".speed-cards-carousel .card").forEach((el) => {
      el.style.height = card_max_height + "px";
    });
  }
}
window.addEventListener("resize", setEqualCardHeight);

// Function to find the tallest floating-info element
function findTallestFloatingInfo() {
  let maxHeight = 0;
  document
    .querySelectorAll(".speed-cards-carousel .card .floating-info")
    .forEach((element) => {
      if (element.offsetHeight > maxHeight) {
        maxHeight = element.offsetHeight;
      }
    });
  return maxHeight;
}

// Adjust the margin top of each .card
function adjustCardMargin() {
  const tallestInfoHeight = findTallestFloatingInfo();
  const additionalMargin = 15;
  document.querySelectorAll(".speed-cards-carousel .card").forEach((card) => {
    card.style.marginTop = tallestInfoHeight + additionalMargin + "px";
  });
}

try {
  // Listener for focus event on elements with class .tt-input
  $(document).on("focus", ".wf-address-checker .typeahead", function () {
    // check window width
    if (window.innerWidth < 768) {
      var $this = $(this);
      var container = $this.closest(".header-address-checker");
      var checkButton = container.find(".check-address");

      //ensure the check button is visible
      checkButton[0].scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });
} catch (e) {
  console.error(e);
}

// Check on page load for a local storage addr data, clear out addr cookies if not found
$(document).ready(function () {
  if (!localStorage.getItem("lumos_address_market")) {
    Cookies.remove("STYXKEY_lumos_promo_zone");
    Cookies.remove("STYXKEY_lumos_address_multigig");
    Cookies.remove("STYXKEY_lumos_address_market");
  }
});


// update broadband labels UPI data on addr
function refreshUPIData() {
  console.log("refreshUPIData");
  // hide labels container
  let techStack = localStorage.getItem("lumos_address_tech_stack");
  if (techStack) {
    // get the address_id from the localStorage
    let address_id = localStorage.getItem("lumos_address_id");
    if (
      localStorage.getItem("lumos_address_universaladdress_id") &&
      localStorage.getItem("lumos_address_universaladdress_id") != "null"
    ) {
      address_id = localStorage.getItem("lumos_address_universaladdress_id");
    }

    // get_plans_by_address ajax call
    $.ajax({
      url: "/wp-content/themes/lumos-tidewater/api_helper.php",
      method: "POST",
      contentType: "application/x-www-form-urlencoded",
      async: false, // no async necessary
      data: {
        action: "get_plans_by_address",
        address_id: address_id,
        feature_id: null,
      },
      success: function (response) {
        // for each item in labels container, check the element's [data-upi] attr, compare it with each return in data[].unique_plan_id, hide labels that are not in the data
        try{
          let data = JSON.parse(response).Data;
          let labels = $(".wf-speed-cards .broadband-label");


          labels.each(function(index, element) {
            // Get the closest .card ancestor's data-name
            var $element = $(element);
            // if there is a slide-wrapper, or get the ancestor slick-slide and look for .shop-now-checkbox which will have data-name
            if ($element.closest('.slide-wrapper').length) {
              var $card = $element.closest('.slide-wrapper').find('> .card');
            } else {
              var $card = $element.closest('.slick-slide').find('.shop-now-checkbox');
            }
            var dataName = $card.data('name');
          
            // Find the matching data where service_plan_name matches data-name
            var matchingData = data.find(function(item) {
              return item.service_plan_name === dataName;
            });
          
            // If matching data is found, update the data-upi of a descendant of the element
            if (matchingData) {
              $element.find('[data-upi]').text(matchingData.unique_plan_id);
            }
          });
        }
        catch(e){
          console.log('error: ', e);
        }
        
      },
      error: function (error) {
        console.error("AJAX error:", error);
      },
    });
  }
}
